import { oc } from "@orpc/contract";
import { z } from "zod";
import { ApiVersionSchema } from "./version.js";
// Every procedure is declared once here (input, output); the server's router and the
// browser's client are both typed from this declaration. Procedures are served at
// POST /api/v5/<area>/<name> as plain JSON (the input is the body, the output the answer: the
// one wire since H.19), and called as client.<area>.<name>(input).
// PR 1's sample: the health procedure.
//
// `.route({ summary, description })` documents each procedure for the browser's RPC
// explorer and the OpenAPI document (openapi.ts); `.meta()` carries the explorer's facts:
// `public` = answers without a session, `idempotencyKey` = the Idempotency-Key header
// must equal the input's requestId, `sessionChanging` = mints or clears the cookie; and
// the key check's (access.ts): `access` = "read" | "write", required on every procedure,
// and `keys: false` = no API key may call it.
export const HealthStatus = z.object({
    status: z.literal("ok"),
    release: z.string().nullable(),
    now: z.string(),
    api: ApiVersionSchema,
});
export const health = {
    check: oc
        .route({
        summary: "Liveness through the procedure handlers",
        description: "Answers ok with the release commit stamped into the image, the server's clock and the wire's version (api.contracts is WIRE_VERSION, the v5-api-version header); touches no session and no database.",
    })
        .meta({ public: true, access: "read" })
        .output(HealthStatus),
};
//# sourceMappingURL=health.js.map